import {
  ADD_LAYER_TO_MAP,
  REMOVE_LAYER_FROM_MAP,
} from '../actions/actionTypes';

const initialState = [];

const layersReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_LAYER_TO_MAP:
      return [...state, payload];
    case REMOVE_LAYER_FROM_MAP:
      return state.filter(
        (layer) => layer.get('title') !== payload.get('title')
      );
    default:
      return state;
  }
};

export default layersReducer;
